/* eslint-disable ember/no-computed-properties-in-native-classes, ember/require-computed-property-dependencies, warp-drive/no-legacy-request-patterns */
import { computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import type { Type } from '@warp-drive/core/types/symbols';
import PostCountBase from './post-count-base';

export default class PostCountPage extends PostCountBase {
  declare [Type]: 'people/post-count-page';

  @computed('itemId')
  get page() {
    if (isEmpty(this.itemId)) {
      return null;
    }
    return this.store.peekRecord('posts/page', this.itemId);
  }
}
